<template>
	<div class="bg-white border rounded-lg p-4">
		<div class="mb-4">
			<h6 class="text-lg uppercase tracking-wider text-gray-500 mb-1">
				Cota TVA
			</h6>
			<v-label class="text-base">
				Cota TVA aplicabila in noul Configurator. Facturarea se face intotdeauna din RO, deci se aplica TVA-ul
				RO pentru toate tarile.
				Preturile din configurator sunt afisate cu TVA inclus.
			</v-label>
		</div>

		<v-form v-model="validForm" ref="formVatRate" @submit.prevent="save">
			<div class="flex">
				<v-text-field v-model="rate" class="w-36 flex-grow-0" dense type="number" min="0" max="100" step="0.5"
					hide-spin-buttons outlined label="TVA" suffix="%"
					:rules="[rules.required, rules.percent]"></v-text-field>
			</div>

			<div class="flex justify-end">
				<v-btn type="submit" color="teal" class="uppercase white--text" :loading="saving"
					:disabled="saving || !hasChanges">Salveaza</v-btn>
			</div>
		</v-form>
	</div>
</template>

<script>
import pricingSection from './pricingSection';

export default {
	name: "VatRate",
	mixins: [pricingSection],
	data() {
		return {
			validForm: false,
			rate: null,
			rules: {
				required: value => (value !== '' && value !== null && value !== undefined) || 'Câmp obligatoriu',
				percent: value => (!isNaN(parseFloat(value)) && parseFloat(value) >= 0 && parseFloat(value) <= 100) || 'Valoare intre 0 si 100',
			},
		};
	},
	computed: {
		saving() {
			return this.section.savingPricingConfig;
		},
		vatRate() {
			return this.section.pricingConfig.vatRate;
		},
		hasChanges() {
			return this.buildPayload() !== this.vatRate;
		}
	},
	methods: {
		// the API stores a fraction ([0, 1]), the form shows a percentage
		syncFromStore() {
			this.rate = Math.round((this.vatRate || 0) * 10000) / 100;
		},
		buildPayload() {
			return Number((parseFloat(this.rate) / 100).toFixed(4));
		},
		async save() {
			const valid = await this.$refs.formVatRate.validate();

			if (valid) {
				this.dispatchSection('savePricingConfig', { vatRate: this.buildPayload() });
			}
		}
	},
	watch: {
		vatRate: 'syncFromStore'
	},
	created() {
		this.syncFromStore();
	}
};
</script>

<style scoped></style>
